import React from 'react';
import './fold.css';

const Fold8 = () => {
  const comparisonData = [
 {
   feature: "Data Extraction",
   aiVoice: "OCR/IDP, 99% accuracy",
   emailOnly: "Manual input, error-prone",
   highlight: true
 },
 {
   feature: "Triage & Risk Score",
   aiVoice: "Automated, policy rules",
   emailOnly: "Manual review",
   highlight: false
 },
 {
   feature: "Straight‑Through Approval",
   aiVoice: "Up to 95%",
   emailOnly: "Rarely achieved",
   highlight: true
 },
 {
   feature: "Fraud Detection",
   aiVoice: "Real-time scoring",
   emailOnly: "Retrospective",
   highlight: false
 },
 {
   feature: "Cycle Time",
   aiVoice: "Minutes",
   emailOnly: "Days or weeks",
   highlight: true
 },
 {
   feature: "Audit & Compliance",
   aiVoice: "Built-in logs",
   emailOnly: "Manual processes",
   highlight: false
 }
];

  return (
    <div className="fold-content">
      <div className="comparison-container">
        <div className="section-header">
          <h2 className="section-title">Feature Comparison</h2>
          <p className="section-subtitle">AI Voice vs Email-only</p>
        </div>

        <div className="comparison-table-wrapper">
          <div className="comparison-table">
            <div className="table-header">
              <div className="header-cell feature-header">Feature</div>
              <div className="header-cell ai-header">AI‑ Agents Driven </div>
              <div className="header-cell email-header">Manual Workflow</div>
            </div>
            
            <div className="table-body">
              {comparisonData.map((row, index) => (
                <div 
                  key={index} 
                  className={`table-row ${row.highlight ? 'highlight-row' : ''}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="table-cell feature-cell">
                    {row.feature}
                  </div>
                  <div className="table-cell ai-cell">
                    {row.aiVoice}
                  </div>
                  <div className="table-cell email-cell">
                    {row.emailOnly}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fold8;